<script lang="ts" setup>
  import type { Song } from '../../../../shared/api/song.ts';
  import SongDetails from './SongDetails.vue';

  defineProps<{
    song: null | Song;
    label: string;
    placeholder?: string;
    verdict?: string;
  }>();
</script>

<template>
  <div class="song-card-horizontal">
    <p class="label">{{ label }}</p>
    <div class="card">
      <div v-if="song" class="song">
        <div class="album-art">
          <img :alt="song.title" :src="song.albumImages[1]" />
        </div>
        <SongDetails class="song-info" :song="song" />
      </div>
      <p v-else class="placeholder">{{ placeholder }}</p>
      <p v-if="verdict" class="verdict">{{ verdict }}</p>
    </div>
  </div>
</template>

<style scoped>
  .song-card-horizontal {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    max-width: var(--control-max-width);
    width: 100%;
  }

  .label {
    font-size: var(--font-size-sm);
    letter-spacing: 0.05em;
    margin: 0;
    text-transform: uppercase;
  }

  .card {
    background: var(--color-surface);
    border-radius: var(--radius-card);
    box-shadow: 0 4px 12px var(--color-shadow);
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: var(--card-padding);
    width: 100%;
  }

  .song {
    align-items: center;
    display: flex;
    gap: 0.75rem;
  }

  .placeholder {
    align-items: center;
    color: var(--color-text-muted);
    display: flex;
    justify-content: center;
    margin: 0;
    min-height: 3.75rem;
    text-align: center;
  }

  .verdict {
    color: var(--color-primary);
    font-size: var(--font-size-xs);
    margin: 0;
  }

  .album-art {
    background: var(--color-placeholder);
    border-radius: calc(var(--radius-card) - var(--card-padding));
    flex-shrink: 0;
    height: 3.75rem;
    overflow: hidden;
    width: 3.75rem;
  }

  .album-art img {
    height: 100%;
    object-fit: cover;
    width: 100%;
  }

  .song-info {
    --song-details-gap: 0.125rem;

    flex: 1;
  }
</style>
